import { render, staticRenderFns } from "./cargoOwnerMfe.vue?vue&type=template&id=63f8c47e&scoped=true"
import script from "./cargoOwnerMfe.vue?vue&type=script&lang=js"
export * from "./cargoOwnerMfe.vue?vue&type=script&lang=js"
import style0 from "./cargoOwnerMfe.vue?vue&type=style&index=0&id=63f8c47e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63f8c47e",
  null
  
)

export default component.exports